import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-040f2408"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emmaus-wrap py-5" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "emmaus-intro text-center mb-5" }, " Avec le Christ, Maître d’initiation, devenir des disciples d’Emmaüs (Lc 24, 13-35) ", -1))
const _hoisted_4 = { class: "row g-4 mb-5" }
const _hoisted_5 = { class: "emmaus-card" }
const _hoisted_6 = { class: "emmaus-number" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-subtitle text-center mb-3" }, "Modules de formation", -1))
const _hoisted_8 = { class: "modules text-center mb-5" }
const _hoisted_9 = { class: "row g-4 mb-5" }
const _hoisted_10 = { class: "group-card" }
const _hoisted_11 = { class: "reasons mb-5" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-subtitle text-center mb-3" }, " 5 bonnes raisons pour s’inscrire au Parcours Disciple d’Emmaüs ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-box mb-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Durée :"),
    /*#__PURE__*/_createTextVNode(" Trois séances de 2h30 par semaine sur deux ans")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Frais d’inscription :"),
    /*#__PURE__*/_createTextVNode(" 10 000 FCFA (1ère année)")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Accompagnement :"),
    /*#__PURE__*/_createTextVNode(" Tutorat, suivi institutionnel, rattrapage des cours possible ")
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/Depliant2.pdf",
    download: "Depliant2",
    class: "btn-download me-3"
  }, " Télécharger le dépliant "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/FicheInscription.pdf",
    download: "FicheInscription",
    class: "btn-outline"
  }, " Télécharger Fiche d'Inscription ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "container" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "section-subtitle text-center mb-3" }, " La liste des cours ", -1))
const _hoisted_21 = { class: "year-tabs text-center mb-4" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "year-title text-center mb-2" }
const _hoisted_24 = { class: "year-note text-center mb-4" }
const _hoisted_25 = { class: "row g-4" }
const _hoisted_26 = { class: "module-card" }
const _hoisted_27 = { class: "module-title" }
const _hoisted_28 = { class: "cost-box mt-5" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Coût de la formation", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.steps, (step, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-4",
            key: i
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(i + 1), 1),
              _createElementVNode("p", null, _toDisplayString(step), 1)
            ])
          ]))
        }), 128))
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.modulesIntro, (m, i) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "module",
            key: i
          }, _toDisplayString(m), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.groups, (g, i) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-md-4",
            key: i
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h5", null, _toDisplayString(g.name), 1),
              _createElementVNode("p", null, _toDisplayString(g.time), 1)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.reasons, (r, i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(r), 1))
          }), 128))
        ])
      ]),
      _hoisted_13,
      _hoisted_14
    ]),
    _hoisted_15,
    _hoisted_16,
    _hoisted_17,
    _hoisted_18,
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          class: _normalizeClass(["year-tab", { active: $data.activeYear === 1 }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.activeYear = 1))
        }, " 1ère année ", 2),
        _createElementVNode("button", {
          class: _normalizeClass(["year-tab", { active: $data.activeYear === 2 }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($data.activeYear = 2))
        }, " 2ème année ", 2)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.years, (year) => {
        return (_openBlock(), _createElementBlock("div", {
          key: year.id
        }, [
          ($data.activeYear === year.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("h4", _hoisted_23, _toDisplayString(year.title), 1),
                _createElementVNode("p", _hoisted_24, _toDisplayString(year.note), 1),
                _createElementVNode("div", _hoisted_25, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(year.modules, (module, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-md-6",
                      key: i
                    }, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("h5", _hoisted_27, _toDisplayString(module.name), 1),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(module.courses, (course, j) => {
                            return (_openBlock(), _createElementBlock("li", { key: j }, _toDisplayString(course), 1))
                          }), 128))
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(year.cost), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}